import React from 'react';

import BulkRegistrationForm from '@payments/organisms/forms/bulk_registration';
import { BulkSelfServeFormProps } from '@payments/types';

const BulkRegistration: React.FC<BulkSelfServeFormProps> = (props) => {
  return (
    <BulkRegistrationForm {...props} />
  );
};

export default BulkRegistration;
